import React, { memo } from 'react';
import classnames from 'classnames';
import Typography from '@cdo/apps/componentLibrary/typography';
import { componentSizeToBodyTextSizeMap } from '@cdo/apps/componentLibrary/common/constants';
import moduleStyles from './toggle.module.scss';
var Toggle = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, name = _a.name, value = _a.value, label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.position, position = _c === void 0 ? 'left' : _c, _d = _a.size, size = _d === void 0 ? 'm' : _d;
    var bodyTextSize = componentSizeToBodyTextSizeMap[size];
    return (React.createElement("label", { className: classnames(moduleStyles.toggle, moduleStyles["toggle-".concat(size)], position === 'right' && moduleStyles['toggle-right']) },
        React.createElement("div", null,
            React.createElement("input", { type: "checkbox", name: name, value: value, checked: checked, onChange: onChange, disabled: disabled }),
            React.createElement("span", { className: moduleStyles.switch },
                React.createElement("i", { className: "fa-solid" }),
                React.createElement("span", null))),
        label && (React.createElement(Typography, { semanticTag: "span", visualAppearance: bodyTextSize }, label))));
};
/**
 * ## Production-ready Checklist:
 *  * (✔) implementation of component approved by design team;
 *  * (✔) has storybook, covered with stories and documentation;
 *  * (✔) has tests: test every prop, every state and every interaction that's js related;
 *  * (see apps/test/unit/componentLibrary/ToggleTest.jsx)
 *  * (?) passes accessibility checks;
 *
 * ###  Status: ```Ready for dev```
 *
 * Design System: Toggle Component.
 * Can be used to render a single Toggle component or as a part of bigger/more complex components (e.g. some form, modal, etc).
 */
export default memo(Toggle);
